import { RouteRecordRaw } from 'vue-router';
import { route } from '@/router/utils'
// import { allPermissions } from '@access/index'
// import { accessPermission } from '@/permissions/permissions'

// const {
//   STAFF: {
//     USER: {
//       VIEW
//     },
//   },
// } = allPermissions

const list = () => import('./List.vue')
const details = () => import('./details/Details.vue')
// Page names
export const REPORTS_LIST_PAGE_NAME = 'cabinet:reports'
export const REPORT_DETAILS_PAGE_NAME = 'cabinet:report-details'
export const REPORT_CREATE_PAGE_NAME = 'cabinet:report-create'
export const REPORT_UPDATE_PAGE_NAME = 'cabinet:report-update'

// URLs
export const REPORTS_LIST_PAGE_URL = ''
export const REPORT_DETAILS_PAGE_URL = 'details/:id/'
export const REPORT_CREATE_PAGE_URL = 'create/'
export const REPORT_UPDATE_PAGE_URL = 'update/:id/'


export function createRoutes(options): RouteRecordRaw[] {
  return [
    route(REPORTS_LIST_PAGE_URL, list, REPORTS_LIST_PAGE_NAME, {
      meta: {
        breadcrumb: 'reports',
        // ...accessPermission([VIEW], options),
      }
    }),
    route(REPORT_DETAILS_PAGE_URL, details, REPORT_DETAILS_PAGE_NAME, {
      meta: {
        breadcrumb: 'report',
        parent: REPORTS_LIST_PAGE_NAME,
        // ...accessPermission([VIEW], options),
      }
    }),
    route(REPORT_CREATE_PAGE_URL, details, REPORT_CREATE_PAGE_NAME, {
      meta: {
        breadcrumb: 'report-create',
        parent: REPORTS_LIST_PAGE_NAME,
        isNew: true,
        // ...accessPermission([VIEW], options),
      }
    }),
    route(REPORT_UPDATE_PAGE_URL, details, REPORT_UPDATE_PAGE_NAME, {
      meta: {
        breadcrumb: 'report-update',
        parent: REPORTS_LIST_PAGE_NAME,
        isUpdate: true,
        isNew: false,
        // ...accessPermission([VIEW], options),
      }
    }),
  ]
}
